import React from 'react';
import { useField, useFormikContext } from 'formik';
import cn from 'classnames';

import InputError, { ERROR_PLACE } from 'components/InputsField/InputError';

import styles from './styles.module.scss';

const SelectOptionBoxes = ({ options, name, onTouch, fullWidth }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  return (
    <div className={cn(fullWidth && styles.fullWidth)}>
      <ul className={cn(styles.options, fullWidth && styles.fullWidthOptions)}>
        {options &&
          options.length > 0 &&
          options.map((role, index) => (
            <li key={index} className={styles.optionWrapper}>
              <button
                className={cn(styles.option, field.value && field.value.includes(role.id) && styles['option--checked'])}
                type="button"
                onClick={() => {
                  setFieldValue(name, [role.id]);
                  onTouch(name, true);
                }}
              >
                {role.value}
              </button>
            </li>
          ))}
      </ul>
      {meta.touched && meta.error && <InputError message={meta.error} mode={ERROR_PLACE.static} />}
    </div>
  );
};

export default SelectOptionBoxes;
